import React, { useState, useEffect, useRef } from 'react';
import GetinTouch from '../GetinTouchform/GetinTouch';
import colors from '../ColorConfig/colorconfig';

const ContactDetails = () => {
  // Office address details
  const officeAddress = "Office No.1, First Floor, Door No.1, B Narasimhan, 3rd St, T. Nagar, Chennai, Tamil Nadu 600017";
  
  // Exact coordinates for precise marker placement
  const latitude = 13.0456586;
  const longitude = 80.2454299;
  
  // Google Maps API Key
  const apiKey = "AIzaSyAMPhdRb83xiMEP7E1Swa1jYP0vKLSM7xY";
  
  // Google Maps URL for opening in a new tab
  const mapsUrl = `https://www.google.com/maps/place/IDLBAY/@${latitude},${longitude},17z/data=!3m1!4b1!4m6!3m5!1s0x39514940fb566b3:0x362581a8f1fb022d!8m2!3d${latitude}!4d${longitude}!16s%2Fg%2F11yjyg3_k7?hl=en&entry=ttu`;

  // Refs and state
  const mapRef = useRef(null);
  const [mapLoaded, setMapLoaded] = useState(false);
  const [mapError, setMapError] = useState(false);

  // Initialize Google Maps
  useEffect(() => {
    // Check if Google Maps API is already loaded
    if (window.google && window.google.maps) {
      initializeMap();
      return;
    }

    // Load Google Maps API
    const script = document.createElement('script');
    script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=places`;
    script.async = true;
    script.defer = true;
    script.onload = () => {
      initializeMap();
    };
    script.onerror = () => {
      setMapError(true);
      setMapLoaded(true);
    };
    
    document.head.appendChild(script);

    return () => {
      // Cleanup
      if (script.parentNode) {
        script.parentNode.removeChild(script);
      }
    };
  }, []);

  const initializeMap = () => {
    try {
      if (!mapRef.current) return;

      const mapOptions = {
        center: { lat: latitude, lng: longitude },
        zoom: 17,
        mapTypeControl: false,
        streetViewControl: true,
        fullscreenControl: true,
        styles: [
          {
            featureType: 'poi.business',
            stylers: [{ visibility: 'on' }]
          }
        ]
      };

      const map = new window.google.maps.Map(mapRef.current, mapOptions);

      // Create custom marker
      const marker = new window.google.maps.Marker({
        position: { lat: latitude, lng: longitude },
        map: map,
        title: 'IDLBay Office',
        animation: window.google.maps.Animation.DROP,
        icon: {
          url: 'data:image/svg+xml;base64,' + btoa(`
            <svg width="40" height="40" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z" 
                    fill="${getComputedStyle(document.documentElement).getPropertyValue('--color-primary') || '#007bff'}" 
                    stroke="white" stroke-width="2"/>
            </svg>
          `),
          scaledSize: new window.google.maps.Size(40, 40),
          anchor: new window.google.maps.Point(20, 40)
        }
      });

      // Add info window
      const infoWindow = new window.google.maps.InfoWindow({
        content: `
          <div style="padding: 8px;">
            <h4 style="margin: 0 0 8px 0; color: #333;">IDLBay Office</h4>
            <p style="margin: 0; color: #666; font-size: 14px;">${officeAddress}</p>
          </div>
        `
      });

      marker.addListener('click', () => {
        infoWindow.open(map, marker);
      });

      setMapLoaded(true);
    } catch (error) {
      console.error('Error initializing map:', error);
      setMapError(true);
      setMapLoaded(true);
    }
  };

  // Fallback static map URL
  const staticMapUrl = `https://maps.googleapis.com/maps/api/staticmap?center=${latitude},${longitude}&zoom=17&size=600x430&markers=color:red%7C${latitude},${longitude}&key=${apiKey}`;

  return (
    <div className="py-5" style={{ backgroundColor: '#f8f9fa' }}>
      <div className="container">
        {/* Main Content Section */}
        <div className="row">
          {/* Left Side - Get In Touch Form (wider column) */}
          <div className="col-lg-8 mb-5 mb-lg-0">
            <div className="pe-lg-4">
              <h3 
                className="h2 fw-bold mb-4"
                style={{ color: colors.bodyBlack }}
              >
                Get In Touch
              </h3>
              <div 
                className="mb-4"
                style={{ 
                  width: '60px', 
                  height: '4px', 
                  backgroundColor: `var(--color-primary)`
                }}
              ></div>
              {/* Pass isContactVersion prop to make the form wider */}
              <GetinTouch isContactVersion={true} />
            </div>
          </div>

          {/* Right Side - Map (narrower column) */}
          <div className="col-lg-4 mt-5">
            <div className="ps-lg-4">
              {/* Map Section */}
              <div className="mb-4">
                <h4 className="fw-bold mb-3">Our Location</h4>
                <div 
                  className="w-100 rounded position-relative"
                  style={{ height: '430px', backgroundColor: '#e9ecef' }}
                >
                  {mapError ? (
                    // Fallback static map
                    <img
                      src={staticMapUrl}
                      alt="IDLBay Office Location"
                      width="100%"
                      height="100%"
                      style={{ border: 0, borderRadius: '8px', objectFit: 'cover' }}
                      onLoad={() => setMapLoaded(true)}
                    />
                  ) : (
                    // Interactive Google Map
                    <div
                      ref={mapRef}
                      style={{ 
                        width: '100%', 
                        height: '100%', 
                        borderRadius: '8px',
                        border: '1px solid #e9ecef'
                      }}
                    />
                  )}
                  
                  {/* Loading overlay */}
                  {!mapLoaded && (
                    <div 
                      className="position-absolute top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
                      style={{
                        backgroundColor: '#e9ecef',
                        borderRadius: '8px',
                        zIndex: 5
                      }}
                    >
                      <div className="spinner-border text-primary" role="status">
                        <span className="visually-hidden">Loading map...</span>
                      </div>
                    </div>
                  )}
                </div>
                
                {/* Address and action buttons */}
                <div className="mt-3">
                  <p className="small text-muted mb-2">
                    {officeAddress}
                  </p>
                  <div className="d-flex gap-2 flex-wrap">
                    <a
                      href={mapsUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="btn btn-outline-primary btn-sm"
                      style={{ fontSize: '12px' }}
                    >
                      <i className="fas fa-map-marker-alt me-1"></i>
                      Open in Maps
                    </a>
                    <a
                      href={`https://www.google.com/maps/dir/?api=1&destination=${latitude},${longitude}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="btn btn-outline-success btn-sm"
                      style={{ fontSize: '12px' }}
                    >
                      <i className="fas fa-directions me-1"></i>
                      Get Directions
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactDetails;